exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".errorPage img{max-width:25rem}.errorPage .description{width:40%;margin-left:30%;margin-top:2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/technical/error_page.scss
// module id = 1385
// module chunks = 0